"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phi = exports.CND = exports.NormalDist = void 0;
class NormalDist {
    static cdf(x) {
        return 0.5 * (1 + this._phi(x / Math.sqrt(2)));
    }
    static pdf(x) {
        const denom = Math.sqrt(Math.PI * 2);
        const numer = Math.exp(-0.5 * Math.pow(x, 2));
        return numer / denom;
    }
    static erf(x) {
        var cof = [
            -1.3026537197817094, 6.4196979235649026e-1, 1.9476473204185836e-2,
            -9.561514786808631e-3, -9.46595344482036e-4, 3.66839497852761e-4,
            4.2523324806907e-5, -2.0278578112534e-5, -1.624290004647e-6,
            1.30365583558e-6, 1.5626441722e-8, -8.5238095915e-8, 6.529054439e-9,
            5.059343495e-9, -9.91364156e-10, -2.27365122e-10, 9.6467911e-11,
            2.394038e-12, -6.886027e-12, 8.94487e-13, 3.13092e-13, -1.12708e-13,
            3.81e-16, 7.106e-15, -1.523e-15, -9.4e-17, 1.21e-16, -2.8e-17,
        ];
        var j = cof.length - 1;
        var isneg = false;
        var d = 0;
        var dd = 0;
        var t, ty, tmp, res;
        if (x < 0) {
            x = -x;
            isneg = true;
        }
        t = 2 / (2 + x);
        ty = 4 * t - 2;
        for (; j > 0; j--) {
            tmp = d;
            d = ty * d - dd + cof[j];
            dd = tmp;
        }
        res = t * Math.exp(-x * x + 0.5 * (cof[0] + ty * d) - dd);
        return isneg ? res - 1 : 1 - res;
    }
    static erfc(x) {
        return 1 - this.erf(x);
    }
    static _phi(x) {
        // save the sign of x
        const sign = x >= 0 ? 1 : -1;
        x = Math.abs(x);
        // z-scores
        const a1 = 0.254829592;
        const a2 = -0.284496736;
        const a3 = 1.421413741;
        const a4 = -1.453152027;
        const a5 = 1.061405429;
        const p = 0.3275911;
        // A&S formula 7.1.26
        const t = 1.0 / (1.0 + p * x);
        const y = 1.0 -
            ((((a5 * t + a4) * t + a3) * t + a2) * t + a1) * t * Math.exp(-x * x);
        return sign * y; // erf(-x) = -erf(x);
    }
}
exports.NormalDist = NormalDist;
/* The cummulative Normal distribution function: */
const CND = (x) => {
    if (x < 0) {
        return 1 - (0, exports.CND)(-x);
    }
    else {
        const k = 1 / (1 + 0.2316419 * x);
        return (1 -
            (Math.exp((-x * x) / 2) / Math.sqrt(2 * Math.PI)) *
                k *
                (0.31938153 +
                    k *
                        (-0.356563782 +
                            k * (1.781477937 + k * (-1.821255978 + k * 1.330274429)))));
    }
};
exports.CND = CND;
/**
 * Taken from wikipedia formula fot greeks. This is small phi used in theta calculation.
 * Be careful there is also in the same formula used capital Phi which is different.
 * @param x
 */
const phi = (x) => {
    return Math.exp(-0.5 * x * x) / Math.sqrt(2 * Math.PI);
};
exports.phi = phi;
